import { render, staticRenderFns } from "./DialogGlobal.vue?vue&type=template&id=251c3baa"
import script from "./DialogGlobal.vue?vue&type=script&lang=js"
export * from "./DialogGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports